import { Route, Routes } from 'react-router-dom';
import EntityFormList from './EntityForm/List.tsx';
import CreateEntityForm from './EntityForm/CreateEntityForm.tsx';
import EntityDetail from './EntityData/EntityDetail.tsx';
import CreateEditFormData from './EntityData/CreateEditFormData.tsx';
import ErrorPage from '../Shared/ErrorPage/index.jsx';

const DatasetsRoutes = () => {
    return (
        <Routes>
            <Route index element={<EntityFormList />} />
            <Route path="" element={<EntityFormList />} />
            <Route path="form-create/*" element={<CreateEntityForm />} />
            <Route path="data-details/:entityFormId" element={<EntityDetail />} />
            <Route path="data/:uuid/:entityFormId" element={<CreateEditFormData />} />
            <Route path="*" element={<ErrorPage />} />
        </Routes>
    );
};

export default DatasetsRoutes;